enum REPORT_STATUS{
    Requested= 'requested',
    Processing= 'processing',
    Done= 'done',
    Error= 'error'
  };
  
  export default REPORT_STATUS;